module.exports = __webpack_public_path__ + "img/img5.0df15f9b.png";